const FooterSection = () => {
  return (
    <>
      <footer
        className='bg-[#121212] bg-cover bg-center text-white font-raleway'
        style={{ backgroundImage: "url('./Background2.png')" }}
      >
        <div className='grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-gray-700'>
          <div className='flex items-center justify-center py-6 space-x-3 mt-[14px]'>
            <div className='w-14 h-14 flex items-center justify-center rounded-full border border-gray-400 text-sm'>
              📍
            </div>
            <div>
              <p className='text-orange-500 text-sm font-raleway'>Location</p>
              <span className='text-white text-sm font-bold '>
                3 Adamu Ciroma Cresent, <br /> Off Ebitu Ukiwe Street, <br />
                Jabi, Abuja 900108
              </span>
            </div>
          </div>

          <div className='flex items-center justify-center py-6 space-x-3 space-y-2 mt-[14px]'>
            <div className='w-14 h-14 flex items-center justify-center rounded-full border border-gray-400 text-sm'>
              📞
            </div>
            <div>
              <p className='text-orange-500 text-sm font-raleway pl-3'>Phone:</p>
              <span className='text-white text-sm font-Sora  px-3'>
                +2347025050009
              </span>
            </div>
          </div>

          <div className='flex items-center justify-center py-6 space-x-3 space-y-2 mt-[14px]'>
            <div className='w-14 h-14 flex items-center justify-center rounded-full border border-gray-400 text-sm'>
              ✉️
            </div>
            <div>
              <p className='text-orange-500 text-sm font-raleway pl-3'>Email:</p>
              <span className='text-white text-sm font-raleway font-bold px-3 pr-4'>
                NGA.Enrichdlp@care.org
              </span>
            </div>
          </div>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-4 gap-8 py-10 px-6 md:px-16'>
          <div className='flex flex-col items-center text-center space-y-3'>
            <img
              src='/Care-logo.png'
              alt='Care eLearning'
              className='w-[150px] sm:w-[180px] md:w-[198px] h-auto'
            />
            <div className='text-center'>
              <p className='mb-4'>
                Follow us on any social platform to <br /> get latest updates
                and events.
              </p>
            </div>

            <div className='flex items-center space-x-2 '>
              <a
                href='https://web.facebook.com/CAREinNigeria/?_rdc=1&_rdr#'
                target='_blank'
                rel='noopener noreferrer'
                className='rounded-full bg-gray-600 px-2 w-[29px] h-[29px] flex items-center justify-center text-xs'
              >
                f
              </a>
              <a
                href='https://www.instagram.com/care_ngr?igsh=MTc1amdpazVtNnRneQ'
                target='_blank'
                rel='noopener noreferrer'
                className='rounded-full bg-gray-600 px-2 w-[29px] h-[29px] flex items-center justify-center text-xs'
              >
                ig
              </a>
              <a
                href='https://x.com/CARE_Nigeria'
                target='_blank'
                rel='noopener noreferrer'
                className='rounded-full bg-gray-600 px-2 w-[29px] h-[29px] flex items-center justify-center text-xs'
              >
                x
              </a>
            </div>
          </div>

          {/* <div className='flex flex-col  space-y-6'>
            <h3 className='font-raleway font-bold text-2xl'>Subscribe</h3>
            <input
              type='email'
              placeholder='Enter your email:'
              className='w-80 px-4 py-4 mb-3 rounded-sm font-raleway text-black'
            />

            <button className='bg-orange-500 text-white px-4 py-4 mr-[199px] rounded font-raleway hover:bg-orange-600 '>
              SUBSCRIBE NOW
            </button>
          </div> */}

          <div className='flex flex-col items-center teaxt-center space-y-5'>
            <h3 className='text-2xl font-bold font-raleway mr-16'>Links</h3>
            <ul className='space-y-3 font-raleway ml-14'>
              {[
                { label: 'Courses', href: '/courses' },
                { label: 'Privacy Policy', href: '/privacy-policy' },
                { label: 'Terms and Conditions', href: '/terms-and-conditions' },
                { label: 'About Us', href: '/about' },
                { label: 'Blog News', href: '/blog' },
              ].map((item, index) => (
                <li key={index}>
                  <a
                    href={item.href}
                    className='flex items-center space-x-6 hover:text-orange-500'
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      className='w-4 h-4 text-white'
                      fill='none'
                      viewBox='0 0 24 24'
                      stroke='currentColor'
                    >
                      <path
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        strokeWidth='2'
                        d='M9 5l7 7-7 7'
                      />
                    </svg>
                    <span>{item.label}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className='flex flex-col  space-y-6'>
            <div className='text-left'>
              <h3 className='font-raleway font-bold text-2xl pr-20'>
                Download
              </h3>
            </div>
            <div className='flex items-center justify-center py-6 space-x-3 '>
              <div className='w-14 h-14 flex items-center justify-center rounded-full border border-gray-400'>
                ⬇️
              </div>
              <div className='text-left'>
                <img
                  src='./Google Play.png'
                  alt='Google Play'
                  className=' h-[62px] w-[290px]'
                />
              </div>
            </div>
          </div>
        </div>
      </footer>

      <footer className='w-full h-[70.3px] bg-black space-y-4 py-16 px-6 md:px-20'>
        <div className='flex justify-center text-center'>
          <div className=' text-white text-center font-raleway text-sm'>
            Copyright © 2026 <span className='text-orange-500'>CARE Nigeria</span>
            {' '}|| All Rights Reserved.
          </div>
        </div>
      </footer>
    </>
  );
};

export default FooterSection;
